export function unwrap<T>(response: any): T {
  return response.data?.data ?? response.data;
}

export function buildQuery(params?: Record<string, unknown>): string {
  if (!params) return '';

  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;
    search.set(key, String(value));
  }

  const query = search.toString();
  return query ? `?${query}` : '';
}
